"use strict";

var GooglePicker = {
    developerKey: 'AIzaSyCrwotL73FL5q_X5ZvixaoYOgqZ4a56JtQ',
    clientId: '88486882721-cac1osvjj8p1r1igak3l8j6v43kol2tl.apps.googleusercontent.com',
    scope: ['https://www.googleapis.com/auth/drive.readonly'],
    locale: 'en',

      // Use the API Loader script to load google.picker and gapi.auth.
    load: function(loadCallback) {
        gapi.load('auth', {'callback': this.onAuthApiLoad});
        gapi.load('picker', {'callback': this.onPickerApiLoad});
    },

    onAuthApiLoad: function() {
        window.gapi.auth.authorize(
            {
		'client_id': GooglePicker.clientId,
		'scope': GooglePicker.scope,
		'immediate': false
            },
            GooglePicker.handleAuthResult);
    },

    onPickerApiLoad: function() {
        GooglePicker.pickerApiLoaded = true;
        GooglePicker.createPicker();
    },
    
    handleAuthResult: function(authResult) {
        if (authResult && !authResult.error) {
            GooglePicker.oauthToken = authResult.access_token;
            GooglePicker.createPicker();
        }
    },

      // Create and render a Picker object for picking user Photos.
    createPicker: function() {
        if (this.pickerApiLoaded && this.oauthToken) {
            var docsView = new google.picker.DocsView(google.picker.ViewId.DOCS);
            docsView.setIncludeFolders(true);
            docsView.setSelectFolderEnabled(true);
            var picker = new google.picker.PickerBuilder().
                addView(docsView).
                addView(google.picker.ViewId.RECENTLY_PICKED).
                enableFeature(google.picker.Feature.SUPPORT_DRIVES).
                setOAuthToken(this.oauthToken).
                setDeveloperKey(this.developerKey).
                setCallback(this.pickerCallback).
                enableFeature(google.picker.Feature.MULTISELECT_ENABLED).
                setLocale(GooglePicker.locale).
                build();
            picker.setVisible(true);

        }
    },

    create: function(pickerCallback) {
	if (pickerCallback) this.pickerCallback = pickerCallback;
        if (this.pickerApiLoaded && this.oauthToken)
	    this.createPicker();
	else
	    this.load();
    },

    pickerCallback: function(data) {
	console.log('picked',data);
    },

};
